module.exports = __webpack_public_path__ + "Flag-732.17181bbc5f066fd9825c5ad847be9d0f.svg";